export { default } from './Slider';